<template>
  <Modal
    v-model="_value"
    width="900"
    title="查看/修改安装订单"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form :model="installOrder" :rules="rules" :label-width="90">
      <Row>
        <Col span="8">
          <FormItem prop="totalAmount" label="应收总金额">
            <InputNumber :disabled="!modify || installOrder.receptDatetime" :min="0" class="field"
                         v-model="installOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="serviceDatetime" label="服务到期时间">
            <DatePicker :disabled="!modify || installOrder.receptDatetime || installOrder.setupDatetime" type="date"
                        v-model="installOrder.serviceDatetime"
                        placeholder="选择日期"></DatePicker>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="businessType" label="业务类型">
            <Select :disabled="!modify || installOrder.receptDatetime" class="field"
                    v-model="installOrder.businessType">
              <Option v-for="item in installOrderBusinessType" :value="item.value" :key="item.value">{{item.label}}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8">
          <FormItem prop="businessUserId" label="跟进业务员">
            <Select :disabled="!modify || installOrder.receptDatetime" class="field"
                    v-model="installOrder.businessUserId">
              <Option v-for="item in businessUsers" :value="item.id"
                      :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">
                {{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="qghyptOption" label="全国货运平台">
            <Select :disabled="!modify" class="field" v-model="installOrder.qghyptOption">
              <Option v-for="item in qghyptOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8">
          <FormItem prop="billType" label="开票类型">
            <Select :disabled="!modify" class="field" v-model="installOrder.billType">
              <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="isfree" label="订单类型">
            <Select class="field" :disabled="!modify" v-model="installOrder.isfree">
              <Option v-for="item in orderTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>
        </Col>
<!--        <Col span="8">-->
<!--          <FormItem prop="multiDevices">-->
<!--            <Checkbox :disabled="!modify" v-model="installOrder.multiDevices">多设备</Checkbox>-->
<!--          </FormItem>-->
<!--        </Col>-->
      </Row>
      <Row>
        <Col span="12">
          <FormItem prop="salesChannelId" label="销售渠道">
            <Select :disabled="!modify"
                    placeholder="请选择销售渠道"
                    v-model="installOrder.salesChannelId"
                    filterable
                    remote
                    :remote-method="searchSalesChannel"
                    class="field" style="width: 80%;"
                    clearable>
              <Option v-for="(option, index) in searchSalesChannelList" :value="option.id" :key="option.id">
                {{option.name}}
              </Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row v-if="installOrder.businessType == 3">
        <Col>
          <FormItem prop="attention">
            <Table border highlight-row size="small" height="150" :columns="columns" :stripe="true" :data="content"
                   ref="table"
                   @on-sort-change="sortChange">
            </Table>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem prop="orderRemark" label="订单备注">
            <Input :disabled="!modify" class="field" style="width: 80%;" v-model="installOrder.remark" type="textarea">
            </Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem prop="history" label="历史记录">
            <Input :disabled="true" class="field" style="width: 80%;" v-model="installOrder.history" type="textarea" :rows="5">
            </Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'installorderbasedetailmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      modify: false,

      initVehicleModel: null,
      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      initClientInfo: null,
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchClientInfoValue: null,
      initVehicleOwnerInfo: null,
      searchVehicleOwnerInfoValue: null,
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      initVehicleType: null,
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      initVehicleBrand: null,
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      qghyptOptions: [
        { label: '不需上传', value: 0 },
        { label: '新车上传', value: 1 },
        { label: '旧车转网', value: 2 }
      ],

      orderTypeOptions: [
        { label: '自费安装模式', value: 1 },
        { label: '普通免费模式', value: 2 },
        { label: '太好保模式', value: 3 }
      ],

      installOrderBusinessType: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 },
        { label: '在网升级', value: 3 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '绿色', value: 5 }
      ],

      businessUsers: [],

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      installOrder: {
        id: null,
        totalAmount: null,
        serviceDatetime: null,
        businessUserId: null,
        businessType: null,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        history: null,
        installerId: null,
        installer: null,
        remark: null,
        receptDatetime: null,
        setupDatetime: null,
        billType: 1,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        newPositioningDeviceModelId: null,
        newPositioningDeviceModel: null,
        vehicleInfoId: null,
        isfree: null,
        salesChannelId: null,
        urgent: '否',
        state: null
      },

      content: [],
      columns: [
        // {
        //   title: 'ID',
        //   resizable: true,
        //   key: 'id',
        //   sortable: 'custom',
        //   tooltip: 'true',
        //   minWidth: 70
        // },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 110
        },
        {
          title: '状态',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          width: 80,
          render: function (h, params) {
            if (params.row.serviceState == 0) {
              return h('div', '停止服务')
            } else if (params.row.serviceState == 1) {
              return h('div', '正常')
            }
          }
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          width: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            } else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '到费期',
          resizable: true,
          key: 'serviceDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110,
          render: function (h, params) {
            if (params.row.serviceDatetime != null) {
              let serviceDatetime = new Date(params.row.serviceDatetime).Format('yyyy年MM月dd日')
              return h('div', serviceDatetime)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          width: 90,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 220,
          render: (h, params) => {
            let display = []

            // return h('div', [
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         console.log(params.row.id)
            //         console.log(this.installOrder.positioningDeviceId)
            //         this.positioningDeviceInfoDetailId = params.row.id
            //         this.positioningDeviceInfoDetailModal = true
            //       }
            //     }
            //   }, '详细信息')
            // )

            display.push(
              h('Checkbox', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: !this.modify,
                  value: this.checkboxValue
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  'on-change': (val) => {
                    // this.checkboxValue = val
                    if (!val) {
                      if (params.row.id = this.installOrder.positioningDeviceId) {
                        this.installOrder.positioningDeviceId = null
                      }
                    } else {
                      if (this.installOrder.positioningDeviceId == null) {
                        this.installOrder.positioningDeviceId = params.row.id
                      }
                    }
                    // this.checkboxValue=val;
                    // this.installOrder.positioningDeviceId = params.row.id;
                  }
                }
              }, '升级设备(勾选拆除设备)')
            )
            // ])

            return h('div', display)
          }
        }
      ],
      checkboxValue: true
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_GetDetail',
      'InstallOrderServ_ModifyInstallOrderBase',
      'VehicleInfoServ_AnalyzeCertificatePicture',
      'VehicleInfoServ_AnalyzeVehicleLicensePicture'
    ]),
    onSuccess () {

    },
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改安装订单',
          content: '<p>确认修改安装订单</p>',
          onOk: () => {
            store.dispatch('InstallOrderServ_ModifyInstallOrderBase', { params: this.installOrder })
              .then(() => {
                this.$Message.success('确认修改安装订单')
                this.$emit('on-success')
                let installOrderId = this._initValue
                store.dispatch('InstallOrderServ_GetDetail', {
                  params: { id: installOrderId }
                }).then(() => {
                  this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
                }).catch(err => {
                  this.$Message.error(err)
                })
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
                let installOrderId = this._initValue
                store.dispatch('InstallOrderServ_GetDetail', {
                  params: { id: installOrderId }
                }).then(() => {
                  this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
                }).catch(err => {
                  this.$Message.error(err)
                })
              })
          },
          onCancel: () => {
            let installOrderId = this._initValue
            store.dispatch('InstallOrderServ_GetDetail', {
              params: { id: installOrderId }
            }).then(() => {
              this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    searchSalesChannel (input) {
      this.searchSalesChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchSalesChannelList = []
        this.searchSalesChannelLoading = false
      } else {
        store.dispatch('SalesChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
          this.searchSalesChannelLoading = false
        }).catch(err => {
          this.searchSalesChannelLoading = false
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.cleanData()
        let installOrderId = this._initValue
        if (installOrderId) {
          store.dispatch('InstallOrderServ_GetDetail', {
            params: { id: installOrderId }
          }).then(() => {
            this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
          }).catch(err => {
            this.$Message.error(err)
          })
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    cleanData () {
      this.installOrder.id = null
      this.installOrder.totalAmount = null
      this.installOrder.serviceDatetime = null
      this.installOrder.businessUserId = null
      this.installOrder.businessType = null
      this.installOrder.multiDevices = false
      this.installOrder.qghyptOption = 0
      this.installOrder.history = null
      this.installOrder.remark = null
      this.installOrder.clientInfoId = null
      this.installOrder.receptDatetime = null
      this.installOrder.setupDatetime = null
      this.installOrder.billType = 1
      this.installOrder.vehicleInfoGroupId = null
      this.installOrder.positioningDeviceId = null
      this.installOrder.newPositioningDeviceModelId = null
      this.installOrder.newPositioningDeviceModel = null
      this.installOrder.vehicleInfoId = null
      this.installOrder.isfree = null
      this.installOrder.salesChannelId = null
      this.checkboxValue = false
    },
    updateInfo (existInstallOrder) {
      this.installOrder.id = existInstallOrder.id
      this.installOrder.totalAmount = existInstallOrder.totalAmount
      this.installOrder.serviceDatetime = existInstallOrder.serviceDatetime === null ? null : new Date(existInstallOrder.serviceDatetime)
      this.installOrder.businessUserId = existInstallOrder.businessUserId
      this.installOrder.businessType = existInstallOrder.businessType
      this.installOrder.multiDevices = existInstallOrder.multiDevices
      this.installOrder.qghyptOption = existInstallOrder.qghyptOption
      this.installOrder.history = existInstallOrder.history
      this.installOrder.remark = existInstallOrder.remark
      this.installOrder.receptDatetime = existInstallOrder.receptDatetime === null ? null : new Date(existInstallOrder.receptDatetime)
      this.installOrder.setupDatetime = existInstallOrder.setupDatetime === null ? null : new Date(existInstallOrder.setupDatetime)
      this.installOrder.billType = existInstallOrder.billType
      this.installOrder.isfree = existInstallOrder.isfree
      this.installOrder.salesChannelId = existInstallOrder.salesChannelId
      this.installOrder.vehicleInfoGroupId = existInstallOrder.vehicleInfoGroupId
      this.installOrder.positioningDeviceId = existInstallOrder.positioningDeviceId
      this.installOrder.newPositioningDeviceModelId = existInstallOrder.newPositioningDeviceModelId
      this.installOrder.newPositioningDeviceModel = existInstallOrder.newPositioningDeviceModel
      this.installOrder.vehicleInfoId = existInstallOrder.vehicleInfoId
      this.installOrder.state = existInstallOrder.state
      this.installOrder.urgent = existInstallOrder.urgent

      if (existInstallOrder.salesChannelId) {
        this.searchSalesChannelList = []
        // existInstallOrder.vehicleInfoGroup.name = existInstallOrder.clientInfo.name + '(' + existInstallOrder.clientInfo.phoneNum + ')'
        this.searchSalesChannelList.push(existInstallOrder.salesChannel)
        this.searchSalesChannelValue = this.searchSalesChannel
      }

      store.dispatch('InstallOrderServ_GetDetail', {
        params: { id: this._initValue }
      }).then(() => {
        // this.installOrder.clientInfoId = existInstallOrder.clientInfoId
        // this.installOrder.tempVehicleInfo.vehicleOwnerInfoId = existInstallOrder.tempVehicleInfo.vehicleOwnerInfoId
        this.installOrder.salesChannelId = existInstallOrder.salesChannelId
      }).catch(err => {
        this.$Message.error(err)
      })

      /**
         * 显示要拆除设备
         */
      this.content = []
      if (this.installOrder.positioningDeviceId) {
        this.checkboxValue = true
        store.dispatch('PositioningDeviceInfoServ_GetDetail', {
          params: {
            id: this.installOrder.positioningDeviceId
          }
        }).then(() => {
          if (store.getters.get_PositioningDeviceInfo_GetDetailResult) {
            this.content.push(store.getters.get_PositioningDeviceInfo_GetDetailResult)
          } else {
            this.content = []
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      } else {
        this.checkboxValue = false
        store.dispatch('PositioningDeviceInfoServ_GetPage', {
          params: {
          },
          urlparams: {
            q: genQueryParam('vehicleInfoId', 'EQ', this.installOrder.vehicleInfoId)
          }
        }).then(() => {
          if (store.getters.get_PositioningDeviceInfo_GetPageResult) {
            store.getters.get_PositioningDeviceInfo_GetPageResult.content.forEach(item => {
              this.content.push(item)
            })
          } else {
            this.content = []
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
